<script setup lang="ts">
import { computed } from "vue";

import DropdownMenu from "~/components/dumb/DropdownMenu.vue";
import { DotsHorizontalIcon } from "~/icons";
import { Placement, WebhookCellType } from "~/shared/enums";
import type { DropdownMenuSection, Webhook } from "~/shared/types";
import { getItemCountText } from "~/utils/common";

const props = defineProps<{
  row: Webhook;
  cellType: WebhookCellType;
  getContextMenuSections?: (webhook: Webhook) => DropdownMenuSection[];
}>();

const eventCount = computed(() => props.row.eventKinds?.length ?? 0);
const eventsText = computed(() =>
  eventCount.value === 0
    ? "No events"
    : getItemCountText(eventCount.value, "event", { noSpecial: true, capitalize: true })
);

const statusText = computed(() => (props.row.enabled ? "" : "Disabled"));
</script>

<template>
  <!-- URL Cell -->
  <div v-if="cellType === WebhookCellType.URL" class="my-2 flex flex-col">
    <span :title="row.title || row.url" class="flex-1 truncate pr-2 text-md">
      {{ row.title || row.url }}
    </span>
    <span v-if="row.title" :title="row.url" class="flex-1 select-text truncate text-sm text-lt">
      {{ row.url }}
    </span>
  </div>

  <!-- Events Cell -->
  <div v-else-if="cellType === WebhookCellType.EVENTS" class="text-sm text-md">{{ eventsText }}</div>

  <!-- Status Cell -->
  <div v-else-if="cellType === WebhookCellType.STATUS" class="text-sm text-md">{{ statusText }}</div>

  <!-- Actions Cell -->
  <DropdownMenu
    v-else-if="cellType === WebhookCellType.ACTIONS"
    :sections="getContextMenuSections ? getContextMenuSections(row) : []"
    :placement="Placement.BOTTOM_RIGHT">
    <div class="flex size-7 items-center justify-center rounded text-lt hover:bg-lt">
      <span class="sr-only">Manage endpoint</span>
      <DotsHorizontalIcon class="icon-md" />
    </div>
  </DropdownMenu>
</template>
